import React from "react";

import InfluencersHome from "./pages/influencers-home/index.js";
import InfluencersInvite from "./pages/influencers-invite/index.js";
import HandleRequestAccountDeletion from "./pages/request-account-delete/index.js";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./assets/root-styles/index.css";
import PrivacyPolicy from "./pages/privacy-policy/index.js";

const currentRoutes = {
  "": InfluencersHome,
  "influencers-invite": InfluencersInvite,
  //"/privacy": PrivacyPolicy,
  "/request-account-deletion": HandleRequestAccountDeletion,
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {Object.keys(currentRoutes).map((path, i) => {
          const Component = currentRoutes[path];
          return (
            <Route
              path={"/" + path}
              key={i}
              element={
                <>
                  <Component />
                </>
              }
            />
          );
        })}
      </Routes>
    </BrowserRouter>
  );
}
